import { useMemo } from 'react';

interface MapState {
  center: google.maps.LatLngLiteral;
  zoom: number;
}

export function useMapState(): MapState {
  const initialMapState = useMemo(() => {
    try {
      const savedCenter = localStorage.getItem("foodweb_map_center");
      const savedZoom = localStorage.getItem("foodweb_map_zoom");
      return {
        center: savedCenter ? JSON.parse(savedCenter) : { lat: 51.0, lng: 4.3 }, // Default center
        zoom: savedZoom ? parseInt(savedZoom, 10) : 12, // Default zoom
      };
    } catch (error) {
      console.error("Error reading map state from localStorage:", error);
      return { center: { lat: 51.0, lng: 4.3 }, zoom: 12 }; // Fallback defaults
    }
  }, []);

  return initialMapState;
}

export function saveMapState(center: google.maps.LatLng, zoom: number): void {
  try {
    localStorage.setItem("foodweb_map_center", JSON.stringify(center.toJSON()));
    localStorage.setItem("foodweb_map_zoom", zoom.toString());
  } catch (error) {
    console.error("Error saving map state to localStorage:", error);
  }
}